import type { PayReportRow } from '../types/payReport'

type ContractTypeOption = { id: string; name: string }

export function createContractTypeLabelResolver(
  contractTypes: ContractTypeOption[] | undefined
): (contractTypeId?: string | null) => string {
  const map = new Map<string, string>()
  contractTypes?.forEach((ct) => {
    map.set(ct.id, ct.name)
  })
  return (contractTypeId) => {
    if (contractTypeId == null || contractTypeId === '') {
      return '-'
    }
    return map.get(contractTypeId) ?? '-'
  }
}

export function getPayReportContractDisplay(
  record: Pick<PayReportRow, 'contractDisplay' | 'contractType'>,
  resolveContractTypeLabel: (contractTypeId?: string | null) => string
): string {
  const explicit = record.contractDisplay?.trim()
  if (explicit) {
    return explicit
  }
  const ct = record.contractType
  if (ct == null) {
    return '-'
  }
  if (typeof ct === 'object' && ct.name?.trim()) {
    return ct.name.trim()
  }
  if (typeof ct === 'string') {
    return resolveContractTypeLabel(ct)
  }
  return '-'
}
